import API from "./API";

const ProjectNotificationService = {
  async getAllProjectNotifications(userId: number) {
    const response = await API().get(
      `ProjectNotification/GetProjectNotificationByUserId/${userId}`,
      {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
  async readAllProjectNotifications(userId: number) {
    await API().put(
      `ProjectNotification/UpdateNotificationActiveState/${userId}`,
      {},
      {
        method: "PUT",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    return;
  },
};

export default ProjectNotificationService;
